import axios from 'axios';
import React, { useContext, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import {
  Button,
  CircularProgress,
  Box,
  Menu,
  MenuItem,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";

import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";

import PublishIcon from "@material-ui/icons/Publish";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import InfoIcon from '@material-ui/icons/Info';


const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  extendedButton: {
    paddingLeft: 0,
    paddingRight: 0,
    minWidth: 30
  },
  remoteMessage: {
    whiteSpace: "pre-line"
  }
}));

export default function PushCreditButton({ channelDisplayNames, channel_shortname, credit_id, credit_title, disabled, external_credit_id, numPersons, saveExternalIDCallback }) {
  const theme = useTheme();
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);


  const pushCredit = (credit_id, channel_shortname, forceNew = false) => {
    setIsLoading(true);
    pageContext.addRunningJob(
      channel_shortname + "_" + credit_id,
      "Übertragung zur " + channelDisplayNames[channel_shortname],
      "Finanzierung " + credit_title,
      Date.now(),
      <PublishIcon />
    );
    if (channel_shortname === "BANKAUSTRIA" || channel_shortname === "ING") {
      setTimeout(() => {
        pageContext.setInfoMessage("Bitte etwas Geduld, bei BankAustria und Bank99 dauert die Übertragung 5-10 Minuten. Du kannst allerdings inzwischen weiter arbeiten oder auch gleichzeitig die Finanzierung an andere Banken übertragen.")
      }, 10000)
    }

    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/channels/pushcredit/${credit_id}/${channel_shortname}`,
      method: 'get',
      params: {
        forcenew: (forceNew ? 1 : 0)
      },
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        console.log(res);
        if (res.data.success) {
          pageContext.setInfoMessage("Die Daten wurden an die " + channelDisplayNames[channel_shortname] + " übertragen.")
          if (res.data.message) {
            pageContext.setInfoDialog({
              open: true,
              title: 'Übertragung der Finanzierung zur ' + channelDisplayNames[channel_shortname],
              message: <>
                Folgende Information kam von der {channelDisplayNames[channel_shortname]} zurück: {"\n"}
                <Box sx={{ whiteSpace: "pre-line" }}>
                  {res.data.message}
                </Box>
              </>,
              handleOK: () => {
                pageContext.setInfoDialog({
                  open: false,
                });
              },
              captionOK: "Ok, verstanden",
            });
          }
        } else {
          if (res.data.message)
            pageContext.setErrorMessage(res.data.message);
          else
            pageContext.setErrorMessage("Bei der Datenübertragung zur " + channelDisplayNames[channel_shortname] + " ist ein Fehler aufgetreten.");
        }
        pageContext.removeRunningJob(channel_shortname + "_" + credit_id);

        if (res.data.external_credit_id) {
          saveExternalIDCallback(res.data.external_credit_id)
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        pageContext.setErrorMessage("Die Verbindung zur " + channelDisplayNames[channel_shortname] + " konnte nicht hergestellt werden!");
        pageContext.removeRunningJob(channel_shortname + "_" + credit_id);
      });
  }

  if (channel_shortname === "EXCEL") {
    return (
      <div className={classes.wrapper}>
        <Button
          variant="contained"
          disabled={isLoading || disabled}
          startIcon={<PublishIcon />}
          target="_blank"
          href={`${process.env.REACT_APP_API_SERVICE_URL}/channels/downloadcredit/${credit_id}/${channel_shortname}/Finanzierungsantrag-${credit_id}.xlsx?token=${userContext.accessToken}`}
        >
          Excel Datei {numPersons > 2 && "1"}
        </Button>
        {numPersons > 2 && <Button
          variant="contained"
          disabled={isLoading || disabled}
          target="_blank"
          href={`${process.env.REACT_APP_API_SERVICE_URL}/channels/downloadcredit/${credit_id}/${channel_shortname}/Finanzierungsantrag-${credit_id}-Teil2.xlsx?token=${userContext.accessToken}`}
        >
          Datei 2
        </Button>}
      </div>
    );
  }

  if (channel_shortname === "BANKAUSTRIAAPI") {
    return (
      <div className={classes.wrapper}>
        <Button
          variant="contained"
          disabled={isLoading || external_credit_id || disabled}
          startIcon={<PublishIcon />}
          onClick={() => {
            pushCredit(credit_id, channel_shortname);
          }}>
          {channelDisplayNames[channel_shortname]}
        </Button>
        {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
        {external_credit_id && <>
          <Button
            className={classes.extendedButton}
            aria-controls="simple-menu"
            aria-haspopup="true"
            variant="contained"
            disabled={isLoading || disabled}
            onClick={(e) => { setAnchorEl(e.currentTarget) }}>
            <MoreVertIcon />
          </Button>
          <Menu
            id="advanced-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => { setAnchorEl(null) }}
          >
            <ListItem>
              <ListItemIcon>
                <InfoIcon />
              </ListItemIcon>
              <ListItemText primary={"Finanzierung wurde bereits übertragen."} />
            </ListItem>
            <MenuItem onClick={() => {
              pushCredit(credit_id, channel_shortname, true);
              setAnchorEl(null)
            }}>
              als neue Finanzierung übertragen
            </MenuItem>
          </Menu>
        </>}
      </div>
    );
  }
  return (
    <div className={classes.wrapper}>
      <Button
        variant="contained"
        disabled={isLoading || disabled}
        startIcon={<PublishIcon />}
        onClick={() => {
          pushCredit(credit_id, channel_shortname);
        }}>
        {channelDisplayNames[channel_shortname]}
      </Button>
      {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
      {external_credit_id && <>
        <Button
          className={classes.extendedButton}
          aria-controls="simple-menu"
          aria-haspopup="true"
          variant="contained"
          disabled={isLoading || disabled}
          onClick={(e) => { setAnchorEl(e.currentTarget) }}>
          <MoreVertIcon />
        </Button>
        <Menu
          id="advanced-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => { setAnchorEl(null) }}
        >
          <ListItem>
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText primary={"Finanzierung wurde bereits mit der ID " + external_credit_id + " übertragen."} />
          </ListItem>
          <MenuItem onClick={() => {
            pushCredit(credit_id, channel_shortname, true);
            setAnchorEl(null)
          }}>
            als neue Finanzierung übertragen
          </MenuItem>
        </Menu>
      </>}
    </div>
  );
}
